import { Defect } from '../../models/defect.model';
import { DefectRef } from '../../models/defect-ref.model';
import { ResultStatus, StepResultKind } from '../../models/test-run.model';

const CAPTURABLE_KINDS: ReadonlySet<StepResultKind> = new Set(['STEP', 'CHECK']);
const CAPTURABLE_STATUSES: ReadonlySet<ResultStatus> = new Set(['FAILED', 'BLOCKED']);

/** Dieselbe Regel wie im Backend (`DefectService`), sonst endet der Knopf in einem 409. */
export function canCaptureDefect(kind: StepResultKind, status: ResultStatus): boolean {
  return CAPTURABLE_KINDS.has(kind) && CAPTURABLE_STATUSES.has(status);
}

export function withDefect(defects: DefectRef[] | undefined, defect: Defect): DefectRef[] {
  return [...(defects ?? []), { id: defect.id, key: defect.key, blocking: defect.blocking }];
}
